import get from 'lodash/get';
import { functionWithFF } from '@atlassian/jira-feature-flagging-utils';
import { useEditField, useFieldConfig } from '@atlassian/jira-issue-field-base';
import { StatusKey } from '@atlassian/jira-providers-issue';
import type { StatusValue } from '../../common/types';
import type { StatusFieldSaveByIdResponse, StatusSaveId, Props } from './types';
import { useStatusMutation } from './use-status-mutation';

const useStatusFieldOld = ({ issueKey, onSuccess, onFailure }: Props) => {
	const [fieldConfig] = useFieldConfig(issueKey, StatusKey);
	const fieldType = get(fieldConfig.value, 'scheme.type', StatusKey);
	const [{ value, loading, error }, { saveValue, resetError }] = useEditField<
		StatusValue | null,
		null
	>({
		fieldKey: StatusKey,
		issueKey,
		fieldType,
		initialValue: null,
		onSuccess,
		onFailure,
	});

	return [
		{ value, loading, error, fieldConfig },
		{ saveValue, resetError },
	] as const;
};

const useStatusFieldNew = ({ issueKey, onSuccess, onFailure }: Props) => {
	const customSaveField = useStatusMutation();
	const [{ value: fieldConfig }] = useFieldConfig(issueKey, StatusKey);
	const fieldType = get(fieldConfig, 'scheme.type', StatusKey);
	const [{ error, value, loading }, { resetError, saveById }] = useEditField<
		StatusValue | null,
		null,
		StatusFieldSaveByIdResponse | null,
		StatusSaveId
	>({
		fieldKey: StatusKey,
		issueKey,
		fieldType,
		onSuccess,
		onFailure,
		initialValue: null,
		saveFieldById: customSaveField,
	});

	return [
		{ error, value, loading, fieldConfig },
		{ resetError, saveById },
	] as const;
};

export const useStatusField = functionWithFF(
	'ui-modifications-issue-view-status-custom-field-support_hwx15',
	useStatusFieldNew,
	// @ts-expect-error TS2345
	useStatusFieldOld,
);
